module.exports = __webpack_public_path__ + "static/media/auto_refinance.f79737db.png";